import { Observable } from "micro-observables";
import { withNewContent } from "@core/paginatedData";
import { SimplePaginatedStore } from "@core/store/paginatedStore";
import { NotificationFilter } from "./notification";
import { NotificationApi } from "./notificationApi";

const NOTIFICATION_PAGE_SIZE = 6;

export class NotificationService {
	notificationStore = new SimplePaginatedStore((page) => this.notificationApi.list(page), NOTIFICATION_PAGE_SIZE);
	notificationSettingsStore = new SimplePaginatedStore<NotificationFilter, unknown>(() =>
		this.notificationApi.getEnabledSettings()
	);

	get unread(): Observable<number> {
		return this.notificationStore.paginatedItems.transform((res) => res?.unread ?? 0);
	}

	constructor(private readonly notificationApi: NotificationApi) {}

	fetchNotifications(): Promise<void> {
		return this.notificationStore.fetch();
	}

	read(id: string): Promise<void> {
		this.notificationStore.paginatedItems.update(
			(notifData) =>
				notifData && {
					...notifData,
					content: notifData.content.map((notif) => (notif.id === id ? { ...notif, read: true } : notif)),
					unread: Math.max(0, notifData.unread - 1),
				}
		);
		return this.notificationApi.read(id);
	}
	readAll(): Promise<void> {
		this.notificationStore.paginatedItems.update(
			(notifData) =>
				notifData &&
				withNewContent(
					{ ...notifData, unread: 0 },
					notifData.content.map((notif) => ({ ...notif, read: true }))
				)
		);
		return this.notificationApi.readAll();
	}

	setEnabledSettings(filter: NotificationFilter, enabled: boolean): Promise<void> {
		this.notificationSettingsStore.paginatedItems.update(
			(notifData) =>
				notifData && {
					...notifData,
					content: enabled
						? notifData.content.push(filter)
						: notifData.content.remove(
								notifData.content.findIndex((item) => item.category === filter.category && item.mode === filter.mode)
							),
				}
		);
		return this.notificationApi.setEnabledSettings(filter, enabled);
	}

	async inviteFriends(emails: string[]): Promise<void> {
		return this.notificationApi.inviteFriends(emails);
	}
}
